export default {"src":"/_next/static/media/others.186136af.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};